import React, { useRef, useEffect } from 'react'
import PropTypes from 'prop-types'

/**
 * Hook that alerts clicks outside of the passed ref
 */
const useOutsideAlerter = (ref, clickedOutside) => {
  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        clickedOutside()
      }
    }
    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [ref, clickedOutside])
}

/**
 * Component that alerts if you click outside of it
 */
const OutsideAlerter = ({ children, clickedOutside }) => {
  const wrapperRef = useRef(null)
  useOutsideAlerter(wrapperRef, clickedOutside)

  return <div ref={wrapperRef}>{children}</div>
}

OutsideAlerter.propTypes = {
  children: PropTypes.element.isRequired,
}

export default OutsideAlerter
